try {
    function rtbWishlist(productId) {
        var prefix = "asia.", hash = "gP6WkNgTUHpy13La3OTA", rtbhTags = [];
        rtbhTags.push("pr_" + hash + "_wishlist_" + productId);
        var key = "__rtbhouse.lid", lid = window.localStorage.getItem(key);
        if (!lid) {
            lid = ""; var pool = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
            for (var i = 0; i < 20; i++) lid += pool.charAt(Math.floor(Math.random() * pool.length));
            window.localStorage.setItem(key, lid);
        }
        rtbhTags.push("pr_" + hash + "_lid_" + lid);
        var ifr = document.createElement("iframe"),
            sr = encodeURIComponent(document.referrer ? document.referrer : ""),
            su = encodeURIComponent(document.location.href ? document.location.href : ""),
            ifrSrc = "https://" + prefix + "creativecdn.com/tags?type=iframe", tmstmp = encodeURIComponent("" + Date.now());
        for (var i = 0; i < rtbhTags.length; i++) { ifrSrc += "&id=" + encodeURIComponent(rtbhTags[i]); }
        ifrSrc += "&su=" + su + "&sr=" + sr + "&ts=" + tmstmp;
        ifr.setAttribute("src", ifrSrc); ifr.setAttribute("width", "1");
        ifr.setAttribute("height", "1"); ifr.setAttribute("scrolling", "no");
        ifr.setAttribute("frameBorder", "0"); ifr.setAttribute("style", "display:none");
        ifr.setAttribute("referrerpolicy", "no-referrer-when-downgrade");
        if (document.body) { document.body.appendChild(ifr); }
        else { window.addEventListener('DOMContentLoaded', function () { document.body.appendChild(ifr); }); }
    };
} catch (e) { }